import React from 'react';
import {
    ViewKontakt
} from '../../../api';
import {
    useGetKontaktaufnahmenByKontaktaufgabeId
} from "../../../client/hooks";
import {useQuery} from "react-query";
import {KontaktaufnahmeProvider} from "../../../Contexts/KontaktaufnahmeContext";
import KontaktCard from "./KontaktCard";

interface KontaktDetailsModalProps {
    open: boolean;
    kontakt: ViewKontakt | null;
    aufgabeId: string;
    onClose: () => void;
    initialKontaktaufnahmeId?: string;
}

const KontaktDetailsModal: React.FC<KontaktDetailsModalProps> = ({
    open,
    kontakt,
    aufgabeId,
    onClose,
    initialKontaktaufnahmeId,
}) => {

    const getKontaktaufnahmenByKontaktaufgabeId = useGetKontaktaufnahmenByKontaktaufgabeId();

    const {
        data: kontaktaufnahmeData
    } = useQuery(
        ['kontaktaufnahme', kontakt?.kontaktaufnahmeId],
        async () => {
            if (!kontakt?.kontaktaufnahmeId) return null;
            return await getKontaktaufnahmenByKontaktaufgabeId(kontakt.kontaktaufnahmeId);
        },
        {
            enabled: open && !!kontakt?.kontaktaufnahmeId,
            staleTime: 0,
            keepPreviousData: false,
        }
    );

    if (!kontakt) {
        return null;
    }


    const sortedKontaktaufnahmen = [...(kontaktaufnahmeData?.kontaktaufnahmen || [])]
        .sort((a, b) => (a.versuchNummer ?? Infinity) - (b.versuchNummer ?? Infinity));

    return (
        <KontaktaufnahmeProvider kontaktaufnahmen={sortedKontaktaufnahmen} initialKontaktaufnahmeId={initialKontaktaufnahmeId}>
            <KontaktCard kontakt={kontakt} kontaktaufnahmen={sortedKontaktaufnahmen} aufgabeId={aufgabeId} open={open} onClose={onClose}/>
        </KontaktaufnahmeProvider>

    );
};

export default KontaktDetailsModal;
